export default __webpack_public_path__ + "static/media/O-141.4f99873a.png";